export default __webpack_public_path__ + "static/media/loggeduser.1c603ae4.jpg";